export const tonal = {
  gray: {
    200: '#A5A5A5',
    600: '#2F2F2F',
    700: '#252525',
    800: '#1B1B1B',
  },
  white: {
    white: '#FFFFFF',
    trans20: 'rgba(255, 255, 255, .2)',
  },
  black: {
    trans30: 'rgba(0, 0, 0, .3)',
  },
}
